import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export const SIZE_LARGE = 'SIZE_LARGE';
export const SIZE_BASE = 'SIZE_BASE';
export const SIZE_SMALL = 'SIZE_SMALL';

const sizeToPixels = {
  SIZE_SMALL: '12px',
  SIZE_BASE: '14px',
  SIZE_LARGE: '28px',
};

export default createReactClass({
  propTypes: {
    size: PropTypes.oneOf([SIZE_LARGE, SIZE_BASE, SIZE_SMALL]),
  },

  getDefaultProps() {
    return {
      size: SIZE_BASE,
    };
  },

  render() {
    const style = {
      fontSize: sizeToPixels[this.props.size],
    };

    return <div className="is-loading-spinner animated infinite pulseOpacity"><i style={style} className="ficon ficon-spin ficon-spinner-third" /></div>;
  },
});



// WEBPACK FOOTER //
// ./app/javascript/components/Spinner.js